import axios from 'axios';
import { getProcessorFmmoMonthlyTotalsQuery, getProcessorsQuery } from './queries';
import generateErrorMessage from './utils/generateErrorMessage';
import _ from 'lodash';
import { arrayToMap } from '../../utils';
import { getBulkQueryData } from './utils';

const getProcessorFmmoMonthlyTotals = async ({ startDate, endDate, selectedFmmo }) => {
    const processorFmmoMonthlyTotalsQuery = getProcessorFmmoMonthlyTotalsQuery({ startDate, endDate, selectedFmmo });
    try {
        const processorTotalsResponse = await axios.get(processorFmmoMonthlyTotalsQuery);

        const processorTotalsData = processorTotalsResponse.data;
        const processorIds = _.uniq(_.map(processorTotalsData, 'processor.id'));
        const processors = await getBulkQueryData(getProcessorsQuery, { fields: ['id', 'fmmo_history'], ids: processorIds }, 'ids');

        const processorsWithRecentFmmo = processors
            .filter((processor) => processor.fmmo_history?.length > 0)
            .map((processor) => {
                const validFmmoHistory = processor.fmmo_history.filter((history) => history.date != null && history.fmmos?.length);
                const sortedHistory = _.orderBy(validFmmoHistory, ['date'], ['desc']);
                const mostRecentHistory = sortedHistory[0];
                const recentPoolingOrder = _.head(mostRecentHistory.fmmos);

                return {
                    ...processor,
                    processor_pooling_fmmo: recentPoolingOrder,
                };
            })
            .filter((processor) => processor.processor_pooling_fmmo != null);

        const processorMap = arrayToMap(processorsWithRecentFmmo, 'id');

        const newProcessorTotalsData = processorTotalsData.map((processor) => {
            const matchedProcessor = processorMap[processor.processor.id];
            const newProcessor = { ...processor };
            if (matchedProcessor?.processor_pooling_fmmo != null) {
                newProcessor.processor_pooling_fmmo = matchedProcessor.processor_pooling_fmmo;
            }
            return newProcessor;
        });

        return newProcessorTotalsData;
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
        const descriptiveError = generateErrorMessage(err, 'get', 'processor fmmo monthly totals');
        throw descriptiveError;
    }
};

export default getProcessorFmmoMonthlyTotals;
